import React, { useState } from 'react';
import { Box, Card, CardContent, CardHeader, Grid, TextField, Typography, Button, Divider, List, ListItem, ListItemText, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const JournalManager = () => {
  const [prompts, setPrompts] = useState([
    'What energized you today?',
    'Describe your current mood and possible triggers.'
  ]);
  const [newPrompt, setNewPrompt] = useState('');

  const addPrompt = () => {
    if (!newPrompt.trim()) return;
    setPrompts([...prompts, newPrompt.trim()]);
    setNewPrompt('');
  };

  const removePrompt = (idx) => {
    setPrompts(prompts.filter((_, i) => i !== idx));
  };

  return (
    <Box className="admin-main">
      <Typography variant="h5" gutterBottom className="panel-section-title">Private Journal Configuration</Typography>
      <Grid container spacing={2} className="panel-grid-gap">
        <Grid item xs={12} md={6} style={{ gridColumn: 'span 6' }}>
          <Card className="panel-card">
            <CardHeader title="Guided Prompts" />
            <Divider />
            <CardContent>
              <Box className="panel-form-field" style={{ display: 'flex', gap: 8 }}>
                <TextField fullWidth placeholder="Add a new prompt" value={newPrompt} onChange={(e) => setNewPrompt(e.target.value)} />
                <Button variant="contained" className="admin-accent-btn" onClick={addPrompt}>Add</Button>
              </Box>
              <List>
                {prompts.map((p, i) => (
                  <ListItem key={i} secondaryAction={<IconButton edge="end" onClick={() => removePrompt(i)}><DeleteIcon /></IconButton>}>
                    <ListItemText primary={p} />
                  </ListItem>
                ))}
              </List>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} style={{ gridColumn: 'span 6' }}>
          <Card className="panel-card">
            <CardHeader title="Overlay Settings" subheader="Manage mood graph overlay defaults" />
            <Divider />
            <CardContent>
              <Typography className="admin-muted-text">Graph and visualization settings can be configured here.</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Box style={{ marginTop: 16 }}>
        <Button variant="contained" className="admin-accent-btn">Save Changes</Button>
      </Box>
    </Box>
  );
};

export default JournalManager;
